/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Empty,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
// import makeTree from 'utils/makeTree';
import TabPane from 'antd/lib/tabs/TabPane';
import { useSelector } from 'react-redux';
import { selectUser } from 'store/auth';
import { checkToken } from 'api/utils';
import API from 'utils/api';
// import { getClasificadoresObjetoGastoInternos } from 'api/catalogos/clasificadorObjetoGasto';
import {
  obtenerRegistrosDe
  ,
} from 'utils/URIsSac';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import {
  CheckCircleOutlined, DownloadOutlined, EditOutlined, EyeOutlined, RedoOutlined,
} from '@ant-design/icons';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import CRUDgeneric from 'utils/CRUDgeneric';
import { getEstadosGlobales } from 'api/catalogos';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';
import { postObtenerReporte } from 'api/reporteador';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getJornadasDetalle } from 'api/catalogos/JornadaDetalle';
import moment from 'moment';
import RegistroGuardiasPrincipal from './RegistroGuadiasPrincipal';
import RegistroGuardiasTable from './RegistroGuardiasTable';
// import { URIconfiguracionesDeSegmentosPresupuestales } from './ConfiguracionDeSegmentos';

const { Text } = Typography;
const RegistroGuardiasMenu = ({ permission }) => {
  const user = useSelector(selectUser);
  const firstTab = 'registro';
  const secondTab = 'autorizar';
  const thirdTab = 'autorizados';
  const fourdTab = 'cancelados';
  const todosTab = 'todos';
  // La pantalla abre en "Todos" (primer tab).
  const [currentParentTabKey, setCurrentParentTabKey] = useState(todosTab);

  const [porAutorizar, setPorAutorizar] = useState([]);
  const [autorizados, setAutorizados] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  // Tab "Todos": registros de Autorizar + Autorizados + Cancelados juntos.
  const [todosRegistros, setTodosRegistros] = useState([]);
  // Dataset filtrado por la tabla (búsqueda/orden) para "seleccionar todos".
  const [currentTableData, setCurrentTableData] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [observaciones, setObservaciones] = useState('');

  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState('');
  const [loadingPdfModal, setLoadingPdfModal] = useState(false);

  const [showSelectionModal, setShowSelectionModal] = useState(false);
  const [configurarGuardias, setConfigurarGuardias] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);

  const [estados, setEstados] = useState([]);

  // Modal edición desde tabs
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFatherData, setEditFatherData] = useState(null);
  const [editRecordId, setEditRecordId] = useState(null);

  // Filtros en cascada para tabs Autorizar / Autorizados / Cancelados
  const [aniosGuardias, setAniosGuardias] = useState([]);
  const [periodosGuardias, setPeriodosGuardias] = useState([]);
  const [filtroAnio, setFiltroAnio] = useState(null);
  const [filtroPeriodo, setFiltroPeriodo] = useState(null);
  const [loadingPeriodos, setLoadingPeriodos] = useState(false);
  const cliente = CRUDgeneric('/nominas/autorizar-registro-dias-guardia/');
  const clienteGuardias = CRUDgeneric('/nominas/registro-dias-guardia/');
  const [visibleEliminar, setVisibleEliminar] = useState(false);
  const [loadingEliminar, setLoadingEliminar] = useState(false);

  const onCancel = () => {
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setObservaciones('');
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await obtenerRegistrosDe('/nominas/registro-dias-guardia-vista-optimized/');
    setPorAutorizar(_data?.filter((register) => (
      register?.estados_globales_id === ESTATUS_ACTIVO
    )));
    setAutorizados(_data?.filter((register) => (
      register?.estados_globales_id === ESTATUS_AUTORIZADO
    )));
    setCancelados(_data?.filter((register) => (
      register?.estados_globales_id === ESTATUS_CANCELADO
    )));
    setTodosRegistros(_data?.filter((register) => (
      [ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO].includes(register?.estados_globales_id)
    )) || []);
    setCurrentTableData([]);
    onCancel();
    setLoading(false);
  };

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [_estados, _generales] = await Promise.all([
        getEstadosGlobales(),
        API.get('/nominas/configurar-guardias-vacacionales-general/').then((r) => r.data).catch(() => []),
      ]);
      await fetchData();
      setEstados(_estados);
      setAniosGuardias(_generales || []);
      const periodosPromises = (_generales || []).map((g) => API.get('/nominas/configurar-guardias-vacacionales/', {
        params: { configurar_guardias_vacacionales_general: g.id },
      }).then((r) => r.data).catch(() => []));
      const _allPeriodos = await Promise.all(periodosPromises);
      setConfigurarGuardias(_allPeriodos.flat());
      setLoading(false);
    };
    fetchAll();
  }, []);

  const handleOnRowClick = async (record) => {
    const isSelected = selectedRowKeys.includes(record.id);

    if (isSelected) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
      setSelectedRows(selectedRows.filter((row) => row.id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
      setSelectedRows([...selectedRows, record]);
    }
  };

  const onFiltroAnioChange = async (anioId) => {
    setFiltroAnio(anioId);
    setFiltroPeriodo(null);
    setPeriodosGuardias([]);
    if (!anioId) return;
    setLoadingPeriodos(true);
    try {
      const resp = await API.get('/nominas/configurar-guardias-vacacionales/', {
        params: {
          estados_globales: 4,
          configurar_guardias_vacacionales_general: anioId,
        },
      });
      setPeriodosGuardias(resp.data || []);
    } catch {
      setPeriodosGuardias([]);
    } finally {
      setLoadingPeriodos(false);
    }
  };

  const onClickEditFromTab = async () => {
    if (!selectedRowKeys.length) return;
    const [registroId] = selectedRowKeys;
    const registro = [...porAutorizar, ...autorizados, ...cancelados].find((r) => r.id === registroId);
    if (!registro) return;
    setLoading(true);
    try {
      const empleadoId = registro.empleado_id ?? registro.empleado;
      const [_datosOp, _jornadasDetalle] = await Promise.all([
        getDatoOperacionalesDeEmpleados({ empleado: empleadoId }),
        getJornadasDetalle(),
      ]);
      const _datoOp = Array.isArray(_datosOp) ? _datosOp[0] : _datosOp;
      const _jornada = _jornadasDetalle?.find((j) => j.id === _datoOp?.jornada);
      const horarioFormateado = _jornada
        ? `De ${_jornada.rango_hora_inicial?.slice(0, 5)} A ${_jornada.rango_hora_final?.slice(0, 5)}`
        : '';
      setEditFatherData({
        id: empleadoId,
        antiguedad_numerico_anos: _datoOp?.antiguedad_numerico_anos,
        antiguedad_numerico_dias: _datoOp?.antiguedad_numerico_dias,
        antiguedad_texto: _datoOp?.antiguedad_texto ?? registro.antiguedad_texto,
        jornada_laboral: horarioFormateado,
        de_las: _jornada?.rango_hora_inicial
          ? moment(_jornada.rango_hora_inicial, 'HH:mm:ss')
          : moment(),
        a_las: _jornada?.rango_hora_final
          ? moment(_jornada.rango_hora_final, 'HH:mm:ss')
          : moment(),
      });
      setEditRecordId(registroId);
      setEditModalOpen(true);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onCloseEditModal = async () => {
    setEditModalOpen(false);
    setEditFatherData(null);
    setEditRecordId(null);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    await fetchData();
  };

  const applyFilters = (data) => {
    if (!filtroAnio && !filtroPeriodo) return [];
    let filtered = data;
    if (filtroAnio) {
      const anio = aniosGuardias.find((a) => a.id === filtroAnio);
      if (anio) {
        const anioStr = String(anio.periodo_fiscal?.periodo ?? anio.periodo_fiscal ?? '');
        filtered = filtered.filter((r) => String(r.periodo_fiscal) === anioStr);
      }
    }
    if (filtroPeriodo) {
      const periodo = periodosGuardias.find((p) => p.id === filtroPeriodo);
      if (periodo) {
        const periodoStr = String(periodo.periodos_vacacionales?.periodo ?? periodo.periodo ?? '');
        filtered = filtered.filter((r) => String(r.periodos_vacacionales_periodo) === periodoStr);
      }
    }
    return filtered;
  };

  const getRegistrosPorTab = () => {
    if (currentParentTabKey === todosTab) return todosRegistros;
    if (currentParentTabKey === secondTab) return porAutorizar;
    if (currentParentTabKey === thirdTab) return autorizados;
    return cancelados;
  };

  // Dataset efectivo: prioriza lo filtrado por la tabla; si no, todo lo del tab actual
  // (ya con los filtros de Año/Periodo), para que "seleccionar todos" abarque todas las
  // páginas y no solo la visible.
  const effectiveData = currentTableData.length
    ? currentTableData
    : applyFilters(getRegistrosPorTab());

  const handleTableChange = (_pagination, _filters, _sorter, extra) => {
    setCurrentTableData(extra?.currentDataSource || []);
  };

  // Checkbox propio en el encabezado en vez de `onSelectAll` de AntD, que solo opera
  // sobre la página actual (patrón de ConsultasDeNombramientos).
  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    columnTitle: (
      <Checkbox
        checked={selectedRowKeys.length > 0 && selectedRowKeys.length === effectiveData.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < effectiveData.length}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedRowKeys(effectiveData.map((row) => row.id));
            setSelectedRows([...effectiveData]);
          } else {
            setSelectedRowKeys([]);
            setSelectedRows([]);
          }
        }}
      />
    ),
    onSelect: (record, selected) => {
      if (selected) {
        setSelectedRowKeys((prev) => [...prev, record.id]);
        setSelectedRows((prev) => [...prev, record]);
      } else {
        setSelectedRowKeys((prev) => prev.filter((k) => k !== record.id));
        setSelectedRows((prev) => prev.filter((row) => row.id !== record.id));
      }
    },
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
  };
  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      // const [key] = selectedRowKeys;
      const keys = selectedRowKeys;
      if (!keys) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede cancelar registros ya autorizados');
        return;
      }
      const ids = keys.map((id) => ({ id }));
      const saved = await cliente.reemplazarRegistro(ESTATUS_CANCELADO, ids);
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      // const [key] = selectedRowKeys;
      const keys = selectedRowKeys;
      if (!keys) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar registros ya autorizados');
        return;
      }
      const ids = keys.map((id) => ({ id }));
      const saved = await cliente.reemplazarRegistro(ESTATUS_AUTORIZADO, ids);
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    try {
      setLoading(true);
      const keys = selectedRowKeys;
      if (!keys?.length) {
        setLoading(false);
        onCancel();
        return;
      }
      const ids = keys.map((id) => ({ id }));
      const saved = await cliente.reemplazarRegistro(ESTATUS_ACTIVO, ids);
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const columns = [
    {
      titleText: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: 150,
    },
    {
      titleText: 'Año',
      dataIndex: 'periodo_fiscal',
      key: 'periodo_fiscal',
      width: 150,
    },
    {
      titleText: 'Periodo Vacacional',
      dataIndex: 'periodos_vacacionales_periodo',
      key: 'periodos_vacacionales_periodo',
      width: 200,
    },
    {
      titleText: 'Días de Guardia',
      dataIndex: 'dias_guardia',
      key: 'dias_guardia',
      width: 150,
      // El API manda los días en ISO (aaaa-mm-dd, separados por coma); se muestran en
      // dd/mm/aaaa como en el resto del sistema, para que la Búsqueda por fecha coincida.
      render: (val) => {
        const dias = Array.isArray(val) ? val : String(val ?? '').split(',');
        return dias.map((d) => d.trim()).filter(Boolean)
          .map((d) => (moment(d, 'YYYY-MM-DD', true).isValid() ? moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY') : d))
          .join(', ');
      },
    },
    {
      titleText: 'No. de Días',
      dataIndex: 'numero_dias',
      key: 'numero_dias',
      width: 150,
    },
    {
      titleText: 'Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 200,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 150,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 190,
    },
    {
      titleText: 'Antiguedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 190,
    },
    {
      titleText: 'Fecha de Registro',
      dataIndex: 'fecha_registro',
      key: 'fecha_registro',
      width: 200,
      // En dd/mm/aaaa (el API la manda en ISO), igual que las demás fechas del sistema.
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    // {
    //   titleText: 'Fecha Inicial',
    //   dataIndex: 'fecha_inicial',
    //   key: 'fecha_inicial',
    //   width: 150,
    // },
    // {
    //   titleText: 'Fecha Final',
    //   dataIndex: 'fecha_final',
    //   key: 'fecha_final',
    //   width: 150,
    // },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_id',
      key: 'estados_globales_id',
      width: 100,
      // Tag con color por estatus (mismo criterio que Registro de Incidencias). El
      // children es el texto, así que filtro y orden siguen funcionando igual.
      render: (val) => {
        const descripcion = estados.find((e) => e.id === val)?.descripcion;
        if (!descripcion) return null;
        let color = 'blue';
        if (val === ESTATUS_AUTORIZADO) color = 'green';
        if (val === ESTATUS_CANCELADO) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  const handleTabChange = async (activeKey) => {
    setCurrentParentTabKey(activeKey);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setCurrentTableData([]);
    if (activeKey !== firstTab) {
      await fetchData();
    }
  };

  const onCancelarMasivo = async () => {
    try {
      setLoading(true);

      // El payload solo construye un arreglo de objetos con los IDs
      const payload = selectedRowKeys.map((id) => ({ id }));

      if (payload.length === 0) {
        setLoading(false);
        return;
      }

      // Hacemos la petición PUT directamente
      const response = await API.put(
        '/nominas/cancelar-guardias-masivo',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response) {
        return;
      }

      message.success('Cancelaciones realizadas con éxito');

      setVisibleCancelar(false);
      setSelectedRows([]);
      setSelectedRowKeys([]);

      await fetchData();
    } catch (err) {
      // onError (utils/handlers.js) normaliza cualquier forma de error del
      // backend (string, array, objeto tipo {non_field_errors: [...]}) a
      // texto legible -- pasar err.response.data.message directo a
      // message.error() truena con "Objects are not valid as a React child"
      // cuando el backend responde con un objeto en vez de un string.
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onClickVerReporte = () => {
    setSelectedPeriodo(null);
    setShowSelectionModal(true);
  };

  const onConfirmSelectionModal = async () => {
    if (!selectedPeriodo) {
      message.warning('Selecciona un periodo vacacional.');
      return;
    }
    setShowSelectionModal(false);
    setLoadingPdfModal(true);
    setShowPdfModal(true);

    const values = {
      ID: 10002,
      Parametros: [
        {
          Nombre: 'configurar_guardias_vacacionales',
          TipoParametro: 'numero',
          Valor: String(selectedPeriodo),
        },
        {
          Nombre: 'usuario',
          TipoParametro: 'id',
          Valor: String(user?.id),
        },
      ],
    };

    try {
      const fileBase64 = await postObtenerReporte(values);
      if (fileBase64) {
        setPdfBase64(fileBase64);
      } else {
        message.error('Error al generar el reporte.');
        setShowPdfModal(false);
      }
    } catch (error) {
      message.error('Error al cargar el reporte.');
      setShowPdfModal(false);
    } finally {
      setLoadingPdfModal(false);
    }
  };

  const onClosePdfModal = () => {
    setShowPdfModal(false);
    setPdfBase64('');
  };

  const filtrosCascada = (
    <Form layout="vertical">
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item label="Año de Guardias" hasFeedback>
            <Select
              allowClear
              placeholder="Selecciona un año"
              value={filtroAnio}
              onChange={onFiltroAnioChange}
              options={(aniosGuardias || []).map((a) => ({
                value: a.id,
                label: String(a.periodo_fiscal?.periodo ?? a.periodo_fiscal ?? a.id),
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item label="Periodo Vacacional" hasFeedback>
            <Select
              allowClear
              placeholder={filtroAnio ? 'Selecciona un periodo' : 'Primero selecciona un año'}
              disabled={!filtroAnio}
              loading={loadingPeriodos}
              value={filtroPeriodo}
              onChange={setFiltroPeriodo}
              options={(periodosGuardias || []).map((p) => ({
                value: p.id,
                label: p.periodos_vacacionales?.periodo ?? p.periodo ?? String(p.id),
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  // ── Acciones por estatus ──────────────────────────────────────────────
  // Cada acción se habilita solo si TODOS los registros seleccionados están en un
  // estatus válido para ella. Los tabs por estatus muestran solo sus acciones; el tab
  // "Todos" muestra todas y el estatus decide cuál aplica.
  const seleccionEnEstados = (estadosPermitidos) => selectedRows.length > 0
    && selectedRows.every((row) => estadosPermitidos.includes(row.estados_globales_id));
  // Cancelar/Reactivar un registro YA Autorizado requiere el permiso de la configuración
  // de guardias (antes solo se validaba en el tab Autorizados, donde todos lo son).
  const bloqueadoPorPermisoAutorizados = selectedRows.some((row) => (
    row.estados_globales_id === ESTATUS_AUTORIZADO
    && row.aplica_cancelacion_registros_dias_guardia_autorizados === false
  ));
  const textoConPermiso = (texto) => (bloqueadoPorPermisoAutorizados
    ? (
      <Tooltip title="No cuenta con los permisos" placement="top">
        <span style={{ display: 'inline-block' }}>{texto}</span>
      </Tooltip>
    )
    : texto);

  const accionEditar = {
    onClick: onClickEditFromTab,
    text: 'Editar',
    icon: <EditOutlined />,
    disabledBySelection: true,
    disabled: selectedRowKeys?.length !== 1,
  };
  const accionAutorizar = {
    onClick: () => setVisibleAutorizar(true),
    permission: { model: 'registrodiasguardia', action: 'autorizar' },
    text: 'Autorizar',
    icon: <CheckCircleOutlined />,
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO]),
    className: 'success',
  };
  const accionCancelar = {
    permission: { model: 'registrodiasguardia', action: 'cancelar' },
    onClick: () => setVisibleCancelar(true),
    text: textoConPermiso('Cancelar'),
    icon: <CheckCircleOutlined />,
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO, ESTATUS_AUTORIZADO]) || bloqueadoPorPermisoAutorizados,
    className: 'cancel',
  };
  const accionReactivar = {
    permission: { model: 'registrodiasguardia', action: 'reactivar' },
    onClick: () => setVisibleReactivar(true),
    text: textoConPermiso('Reactivar'),
    icon: <RedoOutlined />,
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_AUTORIZADO, ESTATUS_CANCELADO]) || bloqueadoPorPermisoAutorizados,
    className: 'success',
  };
  const accionVerReporte = {
    onClick: onClickVerReporte,
    text: 'Ver Reporte',
    icon: <EyeOutlined />,
    disabledBySelection: false,
  };

  // Eliminar (tab "Todos"): borrado lógico de un registro Activo; el backend rechaza
  // estatus que no permiten eliminar.
  const eliminarGuardia = async () => {
    const [id] = selectedRowKeys;
    if (!id) return;
    setLoadingEliminar(true);
    const eliminado = await clienteGuardias.borrarRegistro(id);
    setLoadingEliminar(false);
    if (eliminado) {
      setVisibleEliminar(false);
      await fetchData();
    }
  };

  const renderTablaGuardias = (registros, customActions, controls) => (
    <>
      {filtrosCascada}
      <Table
        cols={columns}
        data={applyFilters(registros)}
        allowExportPDF={false}
        rowSelection={rowSelection}
        handleOnRowClick={handleOnRowClick}
        onTableChange={handleTableChange}
        permission={permission}
        customActions={customActions}
        customActionsDropdown
        customActionsDropdownText="Acciones"
        controls={controls}
        disableDelete={!!controls && (selectedRowKeys.length !== 1
          || !seleccionEnEstados([ESTATUS_ACTIVO]))}
      />
    </>
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
        >
          <Tabs
            type="card"
            activeKey={currentParentTabKey || todosTab} // Evitar undefined
            onChange={handleTabChange}
          >
            <TabPane tab="Todos" key={todosTab} forceRender>
              {/* "Todos": Agregar lleva al tab Registro (donde se captura); Editar y
                  Eliminar van en la barra; Eliminar solo aplica a un registro Activo. */}
              {renderTablaGuardias(
                todosRegistros,
                [accionAutorizar, accionCancelar, accionReactivar, accionVerReporte],
                {
                  onClickAdd: () => handleTabChange(firstTab),
                  onClickEdit: onClickEditFromTab,
                  onClickDelete: () => setVisibleEliminar(true),
                },
              )}
            </TabPane>
            <TabPane
              tab={(
                <span>
                  {' '}
                  Registro
                </span>
              )}
              key={firstTab}
              forceRender
            >
              <RegistroGuardiasPrincipal
                permission={permission}
              />
            </TabPane>
            <TabPane tab="Autorizar" key={secondTab} forceRender>
              {renderTablaGuardias(porAutorizar, [accionEditar, accionAutorizar, accionCancelar])}
            </TabPane>
            <TabPane tab="Autorizados" key={thirdTab} forceRender>
              {renderTablaGuardias(autorizados, [
                accionEditar, accionCancelar, accionReactivar, accionVerReporte,
              ])}
            </TabPane>
            <TabPane tab="Cancelados" key={fourdTab} forceRender>
              {renderTablaGuardias(cancelados, [accionEditar, accionReactivar])}
            </TabPane>
          </Tabs>
        </Card>
        <ModalDelete
          open={visibleEliminar}
          onDelete={eliminarGuardia}
          onCancel={() => setVisibleEliminar(false)}
          loading={loadingEliminar}
          content="el registro de guardia seleccionado"
        />
        <Modal
          open={showPdfModal}
          onCancel={onClosePdfModal}
          footer={null}
          width="90%"
          style={{ top: 20 }}
          bodyStyle={{
            padding: 0,
            height: '80vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Spin spinning={loadingPdfModal} tip="Cargando reporte...">
            <div style={{
              backgroundColor: '#fff',
              padding: '20px 24px',
              borderBottom: '1px solid #f0f0f0',
            }}
            >
              <Row justify="space-between" align="middle">
                <Text strong style={{ fontSize: '18px' }}>
                  Reporte de Guardias
                </Text>
              </Row>
            </div>
            <div style={{
              flex: 1,
              padding: '20px',
              backgroundColor: '#f5f5f5',
              overflow: 'auto',
            }}
            >
              {pdfBase64 ? (
                <iframe
                  src={pdfBase64}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                  }}
                  title="Vista previa del reporte"
                />
              ) : (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  color: '#999',
                }}
                >
                  <Empty description="No hay reporte para mostrar" />
                </div>
              )}
            </div>
            <div style={{
              padding: '16px 24px',
              borderTop: '1px solid #f0f0f0',
              backgroundColor: '#fff',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
            }}
            >
              <Button
                onClick={() => {
                  if (pdfBase64) {
                    const downloadLink = document.createElement('a');
                    const fileName = `Reporte_Guardias_${new Date().getTime()}.pdf`;
                    downloadLink.href = pdfBase64;
                    downloadLink.download = fileName;
                    downloadLink.click();
                  }
                }}
                disabled={!pdfBase64}
                icon={<DownloadOutlined />}
              >
                Descargar
              </Button>
              <Button
                type="primary"
                onClick={onClosePdfModal}
              >
                Cerrar
              </Button>
            </div>
          </Spin>
        </Modal>
        <ModalConfirmation
          onFinish={onCancelarMasivo}
          ConfirmAutorize
          onCancel={() => setVisibleCancelar(false)}
          contentTitle="Cancelar Guardias"
          open={visibleCancelar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle="Autorizar Guardias" // ${form.getFieldValue('periodo_detalle') || ''}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          ConfirmAutorize
          onCancel={() => setVisibleCancelar(false)}
          contentTitle="Cancelar Guardias" // ${form.getFieldValue('periodo_detalle') || ''}`}
          open={visibleCancelar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          contentTitle="Reactivar Guardias"
          open={visibleReactivar}
          loading={loading}
        />
        <Modal
          title="Configurar Reporte de Guardias"
          open={showSelectionModal}
          onCancel={() => {
            setShowSelectionModal(false);
            setSelectedPeriodo(null);
          }}
          onOk={onConfirmSelectionModal}
          okText="Generar Reporte"
          cancelText="Cancelar"
          destroyOnClose
        >
          <Form layout="vertical">
            <Form.Item label="Periodo Vacacional" required>
              <Select
                placeholder="Selecciona un periodo vacacional"
                value={selectedPeriodo}
                onChange={setSelectedPeriodo}
                options={configurarGuardias.map((g) => ({
                  value: g.id,
                  label: `${g.configurar_guardias_vacacionales_general.periodo_fiscal.periodo} - ${g.periodos_vacacionales.periodo} (${g.fecha_inicial} - ${g.fecha_final})`,
                }))}
              />
            </Form.Item>
            <Form.Item label="Usuario">
              <Input
                value={user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : ''}
                disabled
              />
            </Form.Item>
          </Form>
        </Modal>
        {editModalOpen && editFatherData && (
          <RegistroGuardiasTable
            permission={permission}
            fatherData={editFatherData}
            autoEditRecordId={editRecordId}
            hideTable
            onHideTableClose={onCloseEditModal}
          />
        )}
      </Spin>
    </Row>
  );
};

export default RegistroGuardiasMenu;
